import { render, staticRenderFns } from "./EgressRulesTab.vue?vue&type=template&id=5df122d2&scoped=true&"
import script from "./EgressRulesTab.vue?vue&type=script&lang=js&"
export * from "./EgressRulesTab.vue?vue&type=script&lang=js&"
import style0 from "./EgressRulesTab.vue?vue&type=style&index=0&id=5df122d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df122d2",
  null
  
)

export default component.exports